<template>
<div class="content">
  <div class="countDown" @click="goIndex">跳过广告 {{totalTime}}</div>
  <img @click="goIndex" :src="currImg" class="img" alt="" />
</div>
</template>

<script>
export default {
  name: "ad",
  data(){
    return{
        adList:[],
      currImg:'',
      currUrl:null,
      content: '发送验证码',  // 按钮里显示的内容
      totalTime: 5      //记录具体倒计时时间
    }
  },
  created() {
    this.getAd()

  },
  beforeRouteLeave(to, from, next){
    next()
    if (this.clock) {
      clearInterval(this.clock)
      this.clock = null
    }
  },
  methods:{
    goIndex(){
      if (this.currUrl == null){
        console.log('null',this.currUrl)
        this.$router.push('/');
      } else {
        console.log(this.currUrl)
        window.open(this.currUrl)
        // window.location.href(this.currUrl)
      }

    },
    countDown () {
      this.content = this.totalTime  //这里解决3秒不见了的问题
      this.clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime
        if (this.totalTime < 0) { //当倒计时小于0时清除定时器
          window.clearInterval(this.clock)
          // this.content = '重新发送验证码'
          // this.totalTime = 60
          if (this.currUrl == null){
            console.log('null',this.currUrl)
            this.$router.push('/');
          } else {
            console.log(this.currUrl)
            window.open(this.currUrl)
            // window.location.href(this.currUrl)
          }

        }

      },1000)

    },
    async getAd(){
      var data = {
        code: 'launcher'
      }
      const res = await this.$Http.getAdv(data)
      if (res.code==200){

        if (res.data.length>0){
          this.adList = res.data
          // 根据背景图数组的长度随机选择索引
          const randIndex = Math.floor(Math.random() * this.adList.length)
          this.currImg = this.adList[randIndex].image
          this.currUrl = this.adList[randIndex].url
          this.countDown()
        } else {
          this.$router.push('/');
        }
      }else {

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  position: relative;
  img{
    width: 100%;height: 100%;position: fixed;left: 0;top: 0;z-index: 1;
  }
  .countDown{
    position: absolute;
    width: 170px;text-align: center;
    font-size: 26px;
    background: #151515;
    border-radius: 26px;padding: 10px 0;
    background: rgba(0,0,0,0.5);color: #ffffff;
    right: 30px;top: 30px;z-index: 3;
  }
}
</style>
